import { useState } from "react";
import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "../components/Reveal";
import { PILLARS } from "../data/site";

export const Metodo = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="metodo" data-testid="metodo-section" className="relative scroll-mt-24 overflow-hidden bg-[#05070D]/65 py-28 lg:py-36">
      <div className="pointer-events-none absolute left-1/2 top-0 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-[#007BFF]/40 to-transparent" />
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal className="text-center">
          <Eyebrow>04 · Método</Eyebrow>
          <h2 className="mx-auto mt-5 max-w-3xl text-3xl font-semibold tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
            Como a AMB transforma negócios
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-400">
            Estratégia, tecnologia e execução não são etapas separadas — são um
            único fluxo, conectado do diagnóstico ao resultado.
          </p>
        </Reveal>

        <div className="relative mt-20">
          <svg className="absolute left-0 right-0 top-10 hidden h-2 w-full lg:block" aria-hidden="true">
            <motion.line
              x1="8%" y1="4" x2="92%" y2="4"
              stroke="#007BFF" strokeWidth="2" strokeLinecap="round"
              initial={{ pathLength: 0, opacity: 0.3 }}
              whileInView={{ pathLength: 1, opacity: 0.7 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: "easeInOut", delay: 0.3 }}
            />
          </svg>
          <div className="grid gap-6 lg:grid-cols-3" data-testid="pillars-grid">
            {PILLARS.map((p, i) => (
              <Reveal key={p.num} delay={0.15 * i}>
                <button
                  type="button"
                  onMouseEnter={() => setActive(i)}
                  onMouseLeave={() => setActive(null)}
                  onFocus={() => setActive(i)}
                  onBlur={() => setActive(null)}
                  data-testid={`pillar-card-${i}`}
                  className={`group relative w-full cursor-default rounded-2xl border p-9 text-left transition-[border-color,background-color,transform] duration-500 lg:pt-14 ${
                    active === i
                      ? "-translate-y-2 border-[#007BFF]/60 bg-[#0a1424]"
                      : "border-white/[0.07] bg-[#0B0F14]"
                  }`}
                >
                  <span
                    className={`absolute left-9 top-6 hidden h-4 w-4 rounded-full border-2 lg:block transition-colors duration-500 ${
                      active === i ? "border-[#3a9bff] bg-[#007BFF] shadow-[0_0_18px_rgba(0,123,255,0.8)]" : "border-[#1e3a63] bg-[#05070D]"
                    }`}
                    style={{ top: "2.15rem" }}
                  />
                  <span className="text-5xl font-extralight tracking-tight text-[#1e3a63] transition-colors duration-500 group-hover:text-[#3a9bff]">
                    {p.num}
                  </span>
                  <h3 className="mt-5 text-xl font-semibold text-slate-100">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.desc}</p>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
